import { createSlice } from "@reduxjs/toolkit";
import { getUsersAction } from "../../actions/users/getUsersAction";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getUserslice = createSlice({
  name: "getProduct",
  initialState,
  reducers: {
    // cleargetUsersState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getUsersAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// export const { cleargetUsersState } = getUsersSlice.actions;
export default getUserslice.reducer;
